module.exports = __webpack_public_path__ + "img/no-image-available.e45ebaa0.jpg";